import React, { useState } from 'react';
import { Upload, edit,Plus } from "../../../../common/svg";
import CustomButton from "../../../../components/AddButton";
type UploadedImage = {
  url: string;
  name: string;
};

const DocumentUpload: React.FC = () => {
  const [uploadedImages, setUploadedImages] = useState<UploadedImage[]>([]);

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    const newImages = files.map((file) => ({
      url: URL.createObjectURL(file),
      name: file.name,
    }));
    setUploadedImages((prevImages) => [...prevImages, ...newImages]);
  };
 
  const handleClick = () => {
    console.log("Button clicked!");
  };
  const handleRemoveImage = (index: number) => {
    setUploadedImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

 

  return (
    <div className="w-full max-w-[1300px] bg-white h-auto font-poppins p-6 ">
      {/* Header */}
      <div className="flex justify-between items-center">
    {/* Left: Expense Details */}
    <p className="text-[16px] font-[600] text-[#282828] leading-[30px]">Documents</p>
    {/* Right: Buttons */}
    <div className="flex gap-2 ml-3">
    <CustomButton label="" icon={edit}    onClick={handleClick}/>
    <CustomButton label="" icon={Plus}    onClick={handleClick}/>
    </div>
  </div>

      {/* Image Gallery */}
      <div className="flex flex-col lg:flex-row items-start space-y-6 lg:space-x-10 lg:space-y-0">
        <div className="grid grid-cols-5">
          {uploadedImages.map((image, index) => (
            <div
              key={index}
              className="relative p-4 w-[146px] h-[132px] rounded-[20px] flex justify-center items-center flex-col shadow-md border"
            >
              <img
                src={image.url}
                alt={`Uploaded ${index + 1}`}
                className="w-full h-full object-cover rounded-md"
              />
              <input
                type="text"
                value={image.name}
                onChange={(e) => {
                  const newImages = [...uploadedImages];
                  newImages[index].name = e.target.value;
                  setUploadedImages(newImages);
                }}
                className="mt-2 text-center text-sm border border-gray-300 rounded-md p-1 w-full"
              />
              <button
                onClick={() => handleRemoveImage(index)}
                className="absolute top-2 right-2 bg-gray-500 text-white text-xs rounded-[30px] h-[20px] w-[20px] flex items-center justify-center"
              >
                &times;
              </button>
            </div>
          ))}
          {/* Upload Button */}
          <label
            htmlFor="fileInput"
            className="flex items-center cursor-pointer bg-white rounded-[10px] border border-gray-200 w-[200px] h-[56px] ml-20 mt-3"
          >
             <img src={Upload} alt="" className="w-[30px] h-[25px] text-[#282828] mr-auto" />
            <p className="text-[#282828] font-poppins text-[10px] text-center whitespace-nowrap mr-2">
              Drop your images here or <br />
              select click to browse
            </p>
           
          </label>
          <input
            type="file"
            id="fileInput"
            className="hidden"
            onChange={handleImageUpload}
            multiple
            accept="image/*"
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentUpload;
